export default __webpack_public_path__ + "static/media/image-square-1.c6e00cfa.jpg";